import React from "react";

const SecondaryHero = ({ title,titleLast, highlight, description, image }) => {
  return (
    <div className="secondary-hero-section padding-container">
      <div className="page-wrapper">
        <div className="secondary-m1">
          <div className="secondary-hero">
            {/* Text Section */}
            <div className="secondary-hero-text">
              <h1>
                {title}{" "}
                <span className="orange-text">{highlight}</span>
                {titleLast}{" "}
              </h1>
              <p>{description}</p>
            </div>

            {/* Image Section */}
            <div className="secondary-hero-img">
              <img src={image} alt={title} width="100%" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecondaryHero;
